import {catchError, EMPTY, filter, from, Observable, switchMap, take, tap} from 'rxjs';
import {Store} from '@ngxs/store';

import {Injector} from '@angular/core';
import {LoadCurrentClient} from '@store/current-client/current-client.actions';
import {CurrentClientState} from '@store/current-client/current-client.state';
import {TrackingService} from '@core/services/tracking.service';
import {BrndtsService} from '@core/services/brndts.service';
import {CMPService} from '@core/services/cmp.service';
import {AuthState} from '@store/auth/auth.state';
import {InitAuth} from '@store/auth/auth.actions';

export function currentClientInitializerFactory(
  store: Store,
  injector: Injector,
  trackingService: TrackingService,
  brndtsService: BrndtsService,
  cmpService: CMPService,
): () => Observable<unknown> {
  return () => {
    return store.dispatch(new LoadCurrentClient()).pipe(
      catchError(error => EMPTY),
      switchMap(() => store.select(CurrentClientState.getData)),
      filter(Boolean),
      take(1),
      tap(currentClient => {
        const gTagId = currentClient.config?.external_dependencies?.google?.tag;
        const cmpSrc = currentClient.config?.external_dependencies?.cmp?.src;
        const brndts = currentClient.config?.external_dependencies?.brndts;
        store.dispatch(
          new InitAuth(
            !!(
              currentClient.config?.external_dependencies.wicket &&
              currentClient.config?.external_dependencies.wicket?.url
            ),
          ),
        );
        if (cmpSrc) {
          cmpService.init(cmpSrc);
        }
        if (brndts && brndts.api_key && brndts.auth_host) {
          brndtsService.init(brndts.api_key, brndts.auth_host, '.videoAds');
        } else {
          brndtsService.markUnavailable();
        }

        if (gTagId && cmpSrc) {
          // cmp handle integration with google consent mode
          trackingService.initGoogleTagWithCmp(gTagId);
        } else if (gTagId) {
          trackingService.initGoogleTagWithoutCmp(gTagId);
        }
      }),
    );
  };
}
